import React, { Component } from 'react'
import Animation from "./Animation";
export default class HeroSection extends Component {
    render() {
        return (
            <section className="sichkovskyi__hero-section h-screen w-full">
                <div className="container mx-auto flex flex-col items-center justify-center h-full">
                    <Animation />
                </div>
            </section>
        )
    }
}